import React from 'react';
import AuthContainer from '../../components/Auth/AuthContainer';

const Register = () => {
  return <AuthContainer mode="register" />;
};

export default Register;
